module.exports = __webpack_public_path__ + "img/DCT-alt.51374b3c.svg";